import React from 'react';
import styles from '../RateView.module.css';
import { getCurrentResource } from '../../../util/tools';
import { getRefList, setRefList } from '../../../util/localStorage';
import { performApiRequest, REFLIST_IS_ACTUAL_API_URL, REFLIST_LOAD_API_URL} from '../../../util/restapi';
import FilterLabel from './FilterLabel';

const INIT_STATE_STARTED = 'started';
const INIT_STATE_ERROR = 'error';
const INIT_STATE_COMPLETE = 'complete';

class FilterObjectRefList extends React.Component {

	resource = null;
	classId = null;
	listId = null;
	initErrorMessage = null;
	listReferences = [];
	
	constructor(props) {
		super(props);
		this.resource = getCurrentResource().components.rateview.filter.FilterObjectRefList;		
		
		let filter = props.filter;
		this.classId = filter.refClassId;
		this.listId = filter.refListId;
		if( this.listId == undefined || this.listId == null )
			this.listId = '';

		let initialValue =filter.initialValue;
		if( initialValue == null )
			initialValue = '';
		this.state = {
			currentValue: initialValue,
			initState: INIT_STATE_STARTED,
		}
		this.setQueryFilter();
	}
	componentDidMount = async () => {
		if( ! this.classId ) {
			this.initErrorMessage = 'Undefined classId';
			this.setState( { initState: INIT_STATE_ERROR} );
			return;
		}
		let classId = this.classId;
		let listId = this.listId;
		let list = getRefList(classId, listId);
		if( list != null ) {
			let request = {classId: classId, listId: listId, createTime: list.createTime};
			let response = await performApiRequest( REFLIST_IS_ACTUAL_API_URL, request );
			if( ! response.success ) {
				this.initErrorMessage = response.message;
				this.setState( { initState: INIT_STATE_ERROR} );
				return;
			}
			if( ! response.data )
				list = null;
		}
		if( list == null ) {
			let request = {classId: classId, listId: listId};
			let response = await performApiRequest( REFLIST_LOAD_API_URL, request );
			if( ! response.success ) {
				this.initErrorMessage = response.message;
				this.setState( { initState: INIT_STATE_ERROR} );
				return;
			}
			list = response.data;
			setRefList(classId, listId, list);
		}
		this.listReferences = [{id: 0, globalId: '', card: this.resource.noCondition}, ...list.list];
		let rateView = this.props.rateView;
		rateView.registerFilter( this );
		this.setState({initState: INIT_STATE_COMPLETE});
	}
	componentWillUnmount() {
		let rateView = this.props.rateView;
		rateView.unregisterFilter( this );
	}

	clearFilter() {
		this.props.rateView.clearQueryFilter( this.props.filter.predicateId )
		this.setState({currentValue: ''});
	}	
	handleValueChange = (e) => {
		this.props.rateView.clearData();
		this.setState({ currentValue: e.target.value }, this.setQueryFilter);
	}
	setQueryFilter = () => {
		let q = this.props.rateView.query;
		let indexFilter = -1;
		let predicate;
		for(let i=0; i < q.listPredicate.length; i++) {
			if( q.listPredicate[i].predicateId == this.props.filter.predicateId ) {
				indexFilter = i;
				break;
			}
		}
		if( indexFilter < 0 ) {
			if( this.state.currentValue != '' ) {
				predicate = {
					predicateId: this.props.filter.predicateId,
					conditionId: this.props.filter.conditionId,
					value: this.state.currentValue
				};
				q.listPredicate.push( predicate );
			}
		} else {
			if( this.state.currentValue == '' ) {
				q.listPredicate.splice( indexFilter, 1 );
			} else {
				q.listPredicate[indexFilter].value = this.state.currentValue;
			}
		}
	}	

	fetchProfile = () => {
		if( this.state.currentValue )
			return {filterId: this.props.filter.predicateId, value: this.state.currentValue};
		else
			return null;
	}
	applyProfile = (profile) => {
		this.setState({ currentValue: profile.value }, this.setQueryFilter);
	}

	render() {
		let filter = this.props.filter;
		let selectHtml = null;
		if( this.state.initState == INIT_STATE_STARTED ) {
			selectHtml = (<span> ... </span>);
		} else if( this.state.initState == INIT_STATE_ERROR ) {
			selectHtml = (<span>{this.initErrorMessage}</span>);
		} else if( this.state.initState == INIT_STATE_COMPLETE ) {
			let optionsHtml = this.listReferences.map((ref, index) => {
				return (<option key={index} value={ref.globalId}>{ref.card}</option>);
			});
			selectHtml = (
				<select style={{width: '100%'}} value={this.state.currentValue} onChange={this.handleValueChange}>
					{optionsHtml}
				</select>
			);
		}
		
		return (
			<div className={styles.divFilter}>
				<FilterLabel title={filter.title} tooltip={filter.tooltip} />
				<div className={styles.divFilterInput}>
					{selectHtml}
				</div>
			</div>
		);
	}	
}

export default FilterObjectRefList;
